import React from 'react';
import { stampOverlayStyleOnPreviewImage } from '@/utils/imageTemplateDisplayLayout';

/** 列表/弹窗卡片上的印花区域 CSS 叠层 */
export default function TemplateCardStampHints({ stampList = [], layout, keyPrefix = 'stamp' }) {
  if (!Array.isArray(stampList) || stampList.length === 0 || !layout) return null;

  return stampList.map((stamp, idx) => {
    const st = stampOverlayStyleOnPreviewImage(stamp, layout);
    if (!st) return null;
    const label = String(stamp.name || stamp.stampName || '').trim() || '印花';
    return (
      <div
        key={stamp.id || `stamp-${keyPrefix}-${idx}`}
        className="funding-template-card__stamp-hint"
        style={st}
      >
        <div className="funding-template-card__stamp-hint-content">
          <p className="funding-template-card__stamp-hint-label">
            <span>{label}</span>
          </p>
        </div>
      </div>
    );
  });
}
